import React from 'react'
import ReactDOM from 'react-dom'

import anime from 'animejs'
import { NavLink } from 'react-router-dom'
import { Transition } from 'react-transition-group'

import CategoryHeader from './CategoryHeader'

import CourseGrid from './CourseList-Grid'
import CourseListView from './CourseList-List'
import MobileListing from './CourseList-Mobile'

let currentAnimation

const clearCurrentAnimation = () => {
  if (currentAnimation)
    currentAnimation.pause()
}

const pageWidth = window.innerWidth
const pageHeight = window.innerHeight


const animateIn = (courseListingContainer) => {
  clearCurrentAnimation()
  const listItems = courseListingContainer.querySelectorAll('.course')
  currentAnimation = anime.timeline()
  .add({
    targets: listItems,
    opacity: [0,1],
    translateZ: ['-200px', '0px'],
    duration: 500,
    easing: 'easeOutExpo',
    delay: function (el, i, l) {
      return i * 100
    }
  })
}

class CourseList extends React.PureComponent {

  componentDidMount() {
    window.scrollTo(0,0)
    animateIn(ReactDOM.findDOMNode(this))
  }

  componentWillUpdate() {
    //console.log('componentWillUpdate')
  }

  componentDidUpdate() {
      window.scrollTo(0,0)
      animateIn(ReactDOM.findDOMNode(this))
  }

  render() {
    let category = this.props.category

    let CategoryCourses

    if (category !== undefined && category !== 'all-courses') {
      CategoryCourses = this.props.jsonData.filter(v => v.cat_url_title !== undefined && v.cat_url_title.includes(category))
    } else {
      CategoryCourses = this.props.jsonData
      category = 'all-courses'
    }

    //cat_id: 50 english, 51 spanish, 57 french
    const ThisCategoryCourses = CategoryCourses.filter(v => v.cat_id !== undefined && v.cat_id.includes("50") && v.add_to_report.includes('Preview Site') && !v.add_to_report.includes('This Is A Preview Course'))

    // TO-DO: use the sort function...
    // Sort the courses alphabetically
    ThisCategoryCourses.sort(function(a,b) {

      const lowerA = a.en_us_lesson_name.toLowerCase()
      const lowerB = b.en_us_lesson_name.toLowerCase()

      if(lowerA < lowerB) {
        return -1;
      }
      if(lowerA > lowerB) {
        return 1;
      }
      return 0;
    })

    if ( this.props.mobile !== true ) {
      return (
        <div className={"courseList " + this.props.viewState} >
          {this.props.viewState === 'grid' &&
            ThisCategoryCourses.map((i,idx) =>
              <CourseGrid
                loggedInInfo={this.props.loggedInInfo}
                key={idx + '-' + i.entry_id}
                id={i.entry_id}
                courseCategory={category}
                courseName={i.en_us_lesson_name}
                courseImg={i.screenshot}
                courseLanguages={i.add_to_report}
                courseHours={i.lesson_hours}
                courseMins={i.lesson_minutes}
                courseURL={i.url_title}
                supported={this.props.supported}
                themeStyles={this.props.themeStyles}
              />
            )
          }
          {this.props.viewState == 'list' &&
            ThisCategoryCourses.map((i,idx) =>
              <CourseListView
                loggedInInfo={this.props.loggedInInfo}
                key={idx + '-' + i.entry_id}
                id={i.entry_id}
                courseCategory={category}
                courseName={i.en_us_lesson_name}
                courseImg={i.screenshot}
                courseLanguages={i.add_to_report}
                courseHours={i.lesson_hours}
                courseMins={i.lesson_minutes}
                courseURL={i.url_title}
                desc={i.lesson_description}
                localURL={this.props.localURL}
                supported={this.props.supported}
                themeStyles={this.props.themeStyles}
              />
            )
          }
          <div className="courseContainer blank"></div>
          <div className="courseContainer blank"></div>
          <div className="courseContainer blank"></div>
          <div className="courseContainer blank"></div>
          <div className="courseContainer blank"></div>
        </div>
      )
    } else {
      return (
        <div className="mobileList">
          {ThisCategoryCourses.map((i,idx) =>
            <MobileListing
              key={idx + '-' + i.entry_id}
              id={i.entry_id}
              courseCategory={category}
              courseName={i.en_us_lesson_name}
              courseImg={i.screenshot}
              courseLanguages={i.add_to_report}
              courseHours={i.lesson_hours}
              courseMins={i.lesson_minutes}
              courseURL={i.url_title}
              desc={i.lesson_description}
              localURL={this.props.localURL}
              supported={this.props.supported}
              themeStyles={this.props.themeStyles}
            />
          )
        }
        </div>
      )
    }

  }

}

export default CourseList
